<template>
    <div class="info-sonars-container">
        <div class="global-sonar-container">
          <div class="filter-global-container">
            <div class="panel-content-line">
                <input type="checkbox" id="global-sonar-checkbox" name="global-sonar-checkbox" v-model="sonarsGlobal">
                <label for="global-sonar-checkbox">Sónar global</label>
            </div>
            <div class="panel-content-line">
                <input type="checkbox" id="campaigns-sonar-checkbox" name="campaigns-sonar-checkbox" v-model="sonarsCampaigns">
                <label for="campaigns-sonar-checkbox">Sónar por campaña</label>
            </div>
          </div>
          <form :model="form" ref="form" v-on:submit.prevent v-if="sonarsCampaigns">
            <div class="filter-date-container">
              <div class="panel-content-line filter-element">
                  <label for="sonar-start-date">Fecha inicio</label>
                  <br>
                  <input type="date" id="sonar-start-date" name="sonar-start-date" class="custom-input-text" v-model="form.sonarStartDate">
              </div>
              <div class="panel-content-line filter-element">
                  <label for="sonar-start-date">Fecha fin</label>
                  <br>
                  <input type="date" id="sonar-end-date" name="sonar-end-date" class="custom-input-text" v-model="form.sonarEndDate">
              </div>
            </div>
            <div class="panel-content-line filter-element">
              <label for="campaign-filter">Búsqueda de campañas</label>
              <br>
              <input type="text" id="campaign-filter" name="campaign-filter" class="custom-input-text" v-model="form.campaignFilter">
            </div>
            <br>
            <button class="btn-new ml-auto" v-on:click="getFilteredSonars">Filtrar</button>
          </form>
        </div>
    </div>
</template>

<script>
  import {getData} from '../../services/api'

  export default {
    name: 'filterPanelSonars',
    data() {
        return {
          form: {
            sonarStartDate: '',
            sonarEndDate: '',
            campaignFilter: ''
          }
        }
    },
    computed: {
      sonarsGlobal: {
          set () { this.$store.dispatch('changeSonarsGlobalOrCampaigns', {globalOrCampaigns: 'global'}); },
          get () { return this.$store.state.mapLayers.layerSonars.sonarsGlobal }
      },
      sonarsCampaigns: {
          set () { this.$store.dispatch('changeSonarsGlobalOrCampaigns', {globalOrCampaigns: 'campaigns'}); },
          get () { return this.$store.state.mapLayers.layerSonars.sonarsCampaigns }
      },
      sonarsCampaignsList: {
          set (campaignsList) { this.$store.dispatch('changeSonarsCampaignsList', {sonarsCampaignsList: campaignsList}); },
          get () { return this.$store.state.mapLayers.layerSonars.sonarsCampaignsList }
      },
      sonarsCampaignsListFiltered: {
          set (campaignsList) { this.$store.dispatch('changeSonarsCampaignsListFiltered', {sonarsCampaignsListFiltered: campaignsList}); },
          get () { return this.$store.state.mapLayers.layerSonars.sonarsCampaignsListFiltered }
      }
    },
    beforeMount () {
        this.getSonarData()
    },
    methods: {
      getSonarData: function () {
          var url = 'mmdata/sonar-campaigns/'
          getData(url).then(res=> {
              this.sonarsCampaignsList = res.data.sonarCampaigns
              this.sonarsCampaignsListFiltered = res.data.sonarCampaigns
          })
      },
      getFilteredSonars: function () {
        var start = '2000-01-01'
        var end = 'now'
        var campFilter = 'no filter'
        if(this.form.sonarStartDate != '') start = this.form.sonarStartDate
        if(this.form.sonarEndDate != '') end = this.form.sonarEndDate
        if(this.form.campaignFilter != '') campFilter = this.form.campaignFilter
        var url = 'mmdata/sonar-campaigns-filtered/' + start + '/' + end + '/' + campFilter + '/'

        getData(url).then(res=> {
          this.sonarsCampaignsListFiltered = res.data.sonarCampaigns
        })
        .catch(error => {
          this.$noty.error("Error")
        })
      }
    }
  }
</script>

<style scoped>
  .info-sonars-container {
    width: 100%;
    padding: 0px 10px 10px 18px;
  }
  .global-sonar-container {
    display: flex;
    flex-direction: column;
  }
  .panel-content-line{
    font-size: small;
    line-height: 80%;
  }
  .filter-date-container {
    display: flex;
    flex-direction: row;
    margin-bottom: 1em;
    padding-bottom: 1rem;
    border-bottom: solid 1px lightgrey;
  }
  .filter-global-container {
    margin-bottom: 1em;
    padding-bottom: 1rem;
    border-bottom: solid 1px lightgrey;
  }
  .filter-element {
    flex: 1;
    margin: 0.3rem;
  }
  .custom-input-text{
    background-color: #f9f9f9;
    font-size: 12px;
    width: 100%;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: .375rem 1.75rem .375rem .75rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/map/FilterPanelSonars.vue